import Vue from 'vue'
import VueI18n from 'vue-i18n';
import messages from '@/assets/translations'

Vue.use(VueI18n)

const defaultLocale= process.env.VUE_APP_DEFAULT_LANG || 'nl'
export default new VueI18n({
  locale: defaultLocale,
  fallbackLocale: defaultLocale,
  silentTranslationWarn: true,
  messages,
});
